import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useCachePersistorContext } from "~@/context/cache-persistor-context";
import { useSwitchOrganizationMutation } from "~@/graphql/codegen/generated";

const useSwitchOrganization = () => {
  const navigate = useNavigate();
  const [switchOrganization] = useSwitchOrganizationMutation({
    onCompleted() {
      navigate("/");
      window.location.reload();
    },
  });

  const [, , clearCache] = useCachePersistorContext();

  const handleSwitch = useCallback(
    async (oid: string) => {
      clearCache();

      return switchOrganization({
        variables: {
          toOID: oid,
        },
      });
    },
    [clearCache, switchOrganization]
  );

  return handleSwitch;
};

export default useSwitchOrganization;
